__turbopack_context__.v({
  "leftNavEntityListItem": "LeftNavEntityList-module__2AHitW__leftNavEntityListItem",
  "leftNavEntityListItemActive": "LeftNavEntityList-module__2AHitW__leftNavEntityListItemActive",
});
